import { useNavigate } from "react-router-dom";
import { Button, Tooltip } from "@firecms/ui";

export function HomeButton() {
    const navigate = useNavigate();

    return (
        <Tooltip title="Back to Dashboard">
            <Button
                size="small"
                variant="outlined"
                onClick={() => navigate("/")}
                style={{ marginRight: "8px" }}
            >
                <svg
                    className="w-4 h-4 mr-2"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"
                    />
                </svg>
                Home
            </Button>
        </Tooltip>
    );
}
